import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { navigateToRedirectTarget } from '../../redirect-target';
import { AuthApp } from './AuthApp';
import { Intro } from './Intro';
import { Passkey } from './Passkey';
import { SMS } from './SMS';

export enum MfaMode {
  intro,
  sms,
  app,
  passkey
}
export interface IMfaSetupProps {
  onSetupComplete: () => void;
  onError: () => void;
}

function Setup() {
  const [mode, setMode] = useState<MfaMode>(MfaMode.intro);

  const onSetupComplete = useCallback(() => {
    navigateToRedirectTarget();
  }, []);

  let other;
  if (mode != MfaMode.intro) {
    other = (
      <div>
        <button className="mt-4 text-sm text-blue-400" onClick={() => setMode(MfaMode.intro)}>
          Choose a different method
        </button>
      </div>
    );
  }

  let content;
  switch (mode) {
    case MfaMode.intro:
      content = <Intro onToggle={setMode} />;
      break;

    case MfaMode.app:
      content = <AuthApp onSetupComplete={onSetupComplete} />;
      break;

    case MfaMode.sms:
      content = <SMS onSetupComplete={onSetupComplete} />;
      break;

    case MfaMode.passkey:
      content = <Passkey onSetupComplete={onSetupComplete} />;
      break;

    default:
      break;
  }

  return (
    <SwitchTransition>
      <CSSTransition key={mode} classNames="page" timeout={300}>
        <div>
          {content}
          {other}
          <Link className="mt-2 text-sm" to="/login">
            Back to Login
          </Link>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}

export { Setup };
